import styled from 'styled-components';
import CloseGreyCircleFillSvg from '../../assets/hotels/close-grey-circle-fill.svg';

const CloseCircleFillIcon = styled(
  CloseGreyCircleFillSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)(
  props => `
  // margin-left: auto;
  // margin-right: ${props.theme.spacing.base}
  cursor: pointer;
  transform: ${props.transform || 'scale(1)'}
`,
);

export default CloseCircleFillIcon;
